import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Loader from "components/Utilities/Loader";

const CustomButton = ({
  title,
  endIcon,
  width,
  height,
  textColorOnHover,
  borderRadius,
  textColor,
  path,
  type: { background, hover, active, disabled },
  isSubmitting,
  ...rest
}) => {
  const useStyles = makeStyles((theme) => ({
    button: {
      "&.MuiButton-root": {
        ...theme.typography.btn,
        backgroundColor: "red",
        color: textColor,
        width: width,
        borderRadius: borderRadius ? borderRadius : 10,
        height: height ? height : "5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0rem 2.5rem",

        "&:hover": {
          backgroundColor: hover,
          color: textColorOnHover,

          "& .MuiButton-endIcon>*:nth-of-type(1)": {
            color: textColorOnHover,
          },
        },

        "&:active": {
          backgroundColor: active,
          boxShadow: "none",
          color: textColor,
        },

        "&:disabled": {
          opacity: "0.6",
          boxShadow: "none",
          cursor: "no-drop",
        },
        "& .MuiButton-endIcon>*:nth-of-type(1)": {
          fontSize: "2rem",
        },

        "& .MuiButton-endIcon": {
          marginLeft: ".5rem",
          marginTop: "-.2rem",
        },
      },
    },
  }));

  const classes = useStyles();

  return (
    <Button
      variant="contained"
      to={path ? path : ""}
      type="submit"
      endIcon={endIcon}
      className={classes.button}
      {...rest}
    >
      {!isSubmitting && title}{" "}
      {isSubmitting && <Loader size={35} color="info" />}
    </Button>
  );
};

CustomButton.defaultProps = {
  width: "auto",
  textColor: "#fff",
};

CustomButton.propTypes = {
  endIcon: PropTypes.node,
  title: PropTypes.string.isRequired,
  type: PropTypes.object,
  textColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  textColorOnHover: PropTypes.string,
  path: PropTypes.string,
  isSubmitting: PropTypes.bool,
};

export default CustomButton;

export const BackBtn = (props) => {
  const useStyles = makeStyles((theme) => ({
    button: {
      "&.MuiButton-root": {
        fontSize: "16px",
        textTransform: "none",
        borderRadius: 30,
        fontWeight: 500,
        backgroundColor: "transparent",
        color: "#757886",
        border: "1px solid #C4C4C4",
        borderRadius: "40px",
        height: "5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0rem 2.5rem",

        "&:disabled": {
          opacity: "0.6",
          boxShadow: "none",
          cursor: "no-drop",
        },
      },
    },
  }));

  const classes = useStyles();
  return (
    <Button variant="outlined" className={classes.button} {...props}>
      Go back
    </Button>
  );
};
